export default __webpack_public_path__ + "static/media/фото-129.0d124785.jpg";